import { quickWebCreditCardPaymentButton } from "@petsure/core";

/**
 * The input bindings for the AngularJS credit card button component.
 */
export interface QuickWebCreditCardPaymentButtonBindings {
    quickWebTokenHandlerEndpoint:string;
    formUrl: string;
    communityCode: string;
    encryptedUserState: string;
    customerReferenceNumber: string;
    returnUrl: string | (() => Promise<string> | string);
    cancelUrl: string | (() => Promise<string> | string);
    supplierBusinessCode: string | (() => Promise<string> | string);
    partner: string;
    principalAmount: number;
    paymentReference: string | (() => Promise<string> | string);
    requestHeaders: HeadersInit | string;
    mapResponseType: string;
    buttonClasses?: string;
    buttonText?: string;
    onBeforePaymentSubmit?: Function;
}

/**
 * AngularJS controller type
 */
export interface QuickWebCreditCardPaymentButtonController
    extends ng.IController, QuickWebCreditCardPaymentButtonBindings {
    onClick: () => void;
}

/**
 * AngularJS component definition
 */
export const QuickWebCreditCardPaymentButtonComponent: ng.IComponentOptions = {
    bindings: {
        quickWebTokenHandlerEndpoint: '@',
        formUrl: '@',
        communityCode: '@',
        encryptedUserState: '@',
        customerReferenceNumber: '@',
        buttonText: '@?',
        buttonClasses: '@?',
        returnUrl: '&',
        cancelUrl: '&',
        supplierBusinessCode: '&',
        partner: '@',
        principalAmount: '=',
        paymentReference: '&',
        requestHeaders: '@',
        mapResponseType: '@',
        prePaymentCallback: '@',
        onBeforePaymentSubmit: '&?',
        isButtonDisabled: "&?"
    },

    controller: function (
        this: QuickWebCreditCardPaymentButtonController
    ) {
    this.$onInit = () => {
        if (!this.buttonText) {
            this.buttonText = "Pay with Credit Card";
        }
        if (!this.buttonClasses) {
            this.buttonClasses = ""
        }
        if (!this.isButtonDisabled) {
            this.isButtonDisabled = () => false;
        }
        this._clickedDisabled = false;
    };

    this.isDisabled = () => {
        return this._clickedDisabled || this.isButtonDisabled();
    };

    this.onClick = () => {
        try {
            this._clickedDisabled = true;
            quickWebCreditCardPaymentButton({
                quickWebTokenHandlerEndpoint: this.quickWebTokenHandlerEndpoint,
                formUrl: this.formUrl,
                communityCode: this.communityCode,
                customerReferenceNumber: this.customerReferenceNumber,
                returnUrl: this.returnUrl,
                cancelUrl: this.cancelUrl,
                supplierBusinessCode: this.supplierBusinessCode,
                partner: this.partner,
                principalAmount: this.principalAmount,
                paymentReference: this.paymentReference,
                requestHeaders: this.requestHeaders,
                mapResponseType: this.mapResponseType,
                onBeforePaymentSubmit: this.onBeforePaymentSubmit,
            });
        }
        catch (e) {
            this._clickedDisabled = false;
            throw e;
        }
    };
    },

    template: `
        <button class="ps-quick-web-credit-card-payment-button {{$ctrl.buttonClasses}}"
                ng-click="$ctrl.onClick()" ng-disabled="$ctrl.isDisabled()">
        {{$ctrl.buttonText}}
        </button>
    `
};